import { Avatar, Typography, UserIcon } from '@eventbrite/marmalade';
import { ShareModal as GenericShareModal } from '@eventbrite/consumer-search.share-modal';
import { useIntl } from 'react-intl';
import type { OrganizerData } from '@/types/organizer';
import { EVENTBRITE_FACEBOOK_APP_ID } from '@/constants/share';
import { OrganizerBannerBackground } from '../../../_shared/OrganizerBannerBackground';
import styles from './ShareModal.module.scss';

interface Props {
  isShown: boolean;
  onClose: () => void;
  organizer: OrganizerData;
}

export function ShareModal({ isShown, onClose, organizer }: Props) {
  const intl = useIntl();
  const fallbackOrganizerName = intl.formatMessage({
    id: 'this organizer',
    defaultMessage: 'this organizer',
  });
  const resourceName = organizer.name.trim() || fallbackOrganizerName;
  const profilePageUrl =
    typeof window !== 'undefined' && window.location.href
      ? window.location.href
      : organizer.profilePageUrl;

  return (
    <GenericShareModal
      isShown={isShown}
      onClose={onClose}
      resourceName={resourceName}
      resourceUrl={profilePageUrl}
      resourceType="organizer"
      resourceId={organizer.id}
      facebookAppId={EVENTBRITE_FACEBOOK_APP_ID}
      messageTemplate={{
        id: 'Hey! Check out events from {organizerName} {profilePageUrl}',
        defaultMessage: 'Hey! Check out events from {organizerName} {profilePageUrl}',
      }}
      messageValues={{
        organizerName: resourceName,
        profilePageUrl,
      }}
      heroSlot={
        <>
          <div className={styles.hero}>
            <OrganizerBannerBackground
              className={styles.heroBanner}
              coverUrl={organizer.coverUrl}
              avatarUrl={organizer.avatarUrl}
            />
            {organizer.avatarUrl ? (
              <Avatar
                className={styles.heroAvatar}
                imageSrc={organizer.avatarUrl}
                imageAlt=""
                size="large"
              />
            ) : (
              <Avatar
                className={styles.heroAvatar}
                icon={<UserIcon size="medium" />}
                size="large"
              />
            )}
          </div>
          <div className={styles.profileBlock}>
            <div className={styles.nameRow}>
              <Typography variant="heading-md" as="span">
                {organizer.name}
              </Typography>
            </div>
          </div>
        </>
      }
    />
  );
}
